import React from 'react';
import Alert from "react-bootstrap/Alert";
import moment from "moment";
import {Group, Subscription, User, GroupRole} from "fearless-common";
import useGet from "../../components/hooks/useGet";
import Loading from "../../components/Loading";
import {backendEndpoints} from "../../libs/backendEndpoints";
import useAuth from "../../components/hooks/useAuth";
import GroupUserManagement from "../../components/groups/GroupUserManagement";

interface GroupWithUsersAndSubscriptions extends Group {
    users: Array<
      User & { pivot: { role: GroupRole, created_at: string }}
    >;
    subscriptions: Subscription[];
};

/**
 * Component showing the members in a team and ability to modify team members.
 */
export default function GroupEdit({ groupId, onSuccess: propOnSuccess = undefined }: {
    groupId: number;
    onSuccess?: () => void;
}) {
    const { user } = useAuth();
    const {
        data: initGroup,
        isLoading,
        error,
        reload,
    } = useGet<GroupWithUsersAndSubscriptions>({
        endpoint: backendEndpoints.getGroup(groupId),
        params: {
            _with: ['users', 'subscriptions']
        },
    });

    if (typeof error === 'string') return <Alert>{error}</Alert>;

    if (isLoading && !initGroup) return <Loading />


    const loggedInUserPivot = initGroup?.users.find(u => u.id === user?.id)?.pivot;

    return (
        <>
            {loggedInUserPivot
                // The logged-in user recently joined (for instance, via a 'join the team' link
                && loggedInUserPivot.role === GroupRole.Member
                && loggedInUserPivot.created_at > moment().subtract(15, 'minute').toISOString() && (
                    <Alert variant="success">Welcome to the team!</Alert>
                )}
            {initGroup && !isLoading && (
                <GroupUserManagement
                    group={initGroup}
                    reload={reload}
                    onSuccess={() => {
                        reload();
                        if (propOnSuccess) propOnSuccess()
                    }}
                    readOnly={!initGroup?.role || initGroup?.role !== GroupRole.Manager}
                />
            )}
            {/* add spacing */}
            <div className="py-4"/>
        </>
    );
}
